import { API_PROTECTED_PATH, API_URL_PRD } from "../config/config";
import store from "../../store";
import ApiClient from "../requests";

//BIBLIOGRAPHIE
export async function getBibliographieArticle() {
  const _authToken = store.authToken;
  if (!_authToken) return null;

  const Url = `${API_URL_PRD}${API_PROTECTED_PATH}user/getArticle/46`;
  const res = await ApiClient.get(Url, _authToken);

  if (res?.forward?.sections) {
    return res.forward.sections;
  }
  return [];

}